import { Download, UploadFile } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Popover, Stack } from "@mui/material";
import { IDownloadExcelRequest } from "model";
import { DownloadActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { EXPORT_FILE_NAME } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

interface IFilterPopupProps {
  anchor: HTMLButtonElement | null;
  onClose(): void;
}

const FilterPopup = (props: IFilterPopupProps) => {
  const dispatch = useAppDispatch();
  const { anchor, onClose } = props;
  const open = Boolean(anchor);
  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );
  const downloadMaterialRequisitionForm = async () => {
    const request: IDownloadExcelRequest = {
      fileName: EXPORT_FILE_NAME.materialRequisitionForm,
    };
    dispatch(DownloadActions.downloadMaterialRequisitionForm.request(request));
  };

  const downloadMaterialMovementForm = async () => {
    const request: IDownloadExcelRequest = {
      fileName: EXPORT_FILE_NAME.materialMovementForm,
    };
    dispatch(DownloadActions.downloadMaterialMovementForm.request(request));
  };

  const downloadPackagingMovementForm = async () => {
    const request: IDownloadExcelRequest = {
      fileName: EXPORT_FILE_NAME.packagingMovementForm,
    };
    dispatch(DownloadActions.downloadPackagingMovementForm.request(request));
  };

  return (
    <Popover
      id={"filter"}
      open={open}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Stack direction={"row"} spacing={2} sx={{ padding: "20px" }}>
        <LoadingButton
          startIcon={<Download />}
          loading={downloading}
          variant="contained"
          onClick={downloadMaterialRequisitionForm}
        >
          {I18nTranslator(translations.button.exportRequestDocs)}
        </LoadingButton>
        <LoadingButton
          startIcon={<Download />}
          loading={downloading}
          variant="contained"
          onClick={downloadMaterialMovementForm}
        >
          {I18nTranslator(translations.button.exportMaterialRequisitonDocs)}
        </LoadingButton>
        <LoadingButton
          startIcon={<Download />}
          loading={downloading}
          variant="contained"
          onClick={downloadPackagingMovementForm}
        >
          {I18nTranslator(translations.button.exportPackagingRequisitonDocs)}
        </LoadingButton>
      </Stack>
    </Popover>
  );
};

export default FilterPopup;
